import React from 'react';

import CoursePausePendingRequestsTable from './CoursePausePendingRequestsTable';
import CoursePauseRequestApproveModal from './CoursePauseRequestApproveModal';
import styles from './CoursePausePendingPage.module.scss';

function CoursePausePendingPage() {
  return (
    <div className={styles.root}>
      <CoursePauseRequestApproveModal />
      <CoursePausePendingRequestsTable />
    </div>
  );
}

export default CoursePausePendingPage;
